import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { TranslateService } from "@root/shared/service/translate.service";

@Directive({
  selector: "[hostClipboard]",
})
export class ClipboardDirective implements AfterViewInit, OnDestroy {
  _clipboardData;
  @Input()
  get clipboardData() {
    return this._clipboardData;
  }
  set clipboardData(value) {
    this._clipboardData = value;
    if (this._clipboardData) {
      this.el.nativeElement.dataset["clipboardText"] = this._clipboardData;
    }
  }

  private instance;

  constructor(
    private el: ElementRef,
    private t: TranslateService,
    private msg: NzMessageService,
  ) {}

  ngAfterViewInit() {
    this.el.nativeElement.dataset["clipboardText"] = this.clipboardData;
    this.instance = new ClipboardJS(this.el.nativeElement);
    this.instance.on("success", () => {
      this.msg.success(this.t.t("success.copy"));
    });
  }

  ngOnDestroy() {
    this.instance && this.instance.destroy();
  }
}
